<template>
  <div style="width:100%">
    <el-input
      v-model="new_value"
      size="small"
      :class="type == 'name' ? 'member-edit-input' : ''"
      :disabled="is_registered"
      :placeholder="type == 'email' ? 'メールアドレスを入力してください' : ''"
      @change="sync()"
    ></el-input> 
  </div>
</template>

<script>
export default {
  name: "memberInput",
  props: ["value", "type", "is_registered", "super_admin_member"],
  components: {},
  data() {
    return {
      new_value: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.new_value = this.value;
  },
  methods: {
    sync() {
      this.$emit("update:value", this.new_value);
      this.$emit("editHandler");
    },
  },
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
  watch: {},
};
</script>
